function init_basic_tooltips() {

    //Initialise custom tooltips
    tippy('.tippy', {
        theme: 'light custom-tooltip',
        arrow: false,
        animateFill: false,
        animation: 'scale',
        maxWidth: 420,
        delay: [200, 0],
        distance: 20
    });
}

function init_tooltips() {
    init_basic_tooltips();
}

$(function() {
    //Initialise custom tooltips
    init_tooltips();
});
